export interface ActivityDay {
  label: string;
  created: number;
  done: number;
}

/** Portul `activityChart()` din mockup: bare create / finalizate pe ultimele 7 zile. */
export function ActivityChart({ days }: { days: ActivityDay[] }) {
  const max = Math.max(1, ...days.map((d) => Math.max(d.created, d.done)));
  const bottom = 144;
  const h = 129;
  const width = 650;
  const step = days.length ? 600 / days.length : 86;
  return (
    <svg
      viewBox={`0 0 ${width} 178`}
      role="img"
      aria-label="Operațiuni create și finalizate în ultimele șapte zile"
      style={{ width: '100%', height: 'auto' }}
    >
      {[0, 0.5, 1].map((n) => (
        <g key={n}>
          <line
            x1={33}
            y1={bottom - h * n}
            x2={635}
            y2={bottom - h * n}
            stroke="#ecf0f6"
            strokeDasharray="3 4"
          />
          <text x={22} y={bottom - h * n + 3} textAnchor="end" fill="#a8b3c2" fontSize={9}>
            {Math.round(max * n)}
          </text>
        </g>
      ))}
      {days.map((d, i) => {
        const cx = 70 + i * step;
        return (
          <g key={d.label + i}>
            <rect
              x={cx - 20}
              y={bottom - (d.created / max) * h}
              width={17}
              height={Math.max(2, (d.created / max) * h)}
              rx={3}
              fill="#3878df"
            >
              <title>{`${d.label}: ${d.created} create`}</title>
            </rect>
            <rect
              x={cx + 2}
              y={bottom - (d.done / max) * h}
              width={17}
              height={Math.max(2, (d.done / max) * h)}
              rx={3}
              fill="#bccfeb"
            >
              <title>{`${d.label}: ${d.done} finalizate`}</title>
            </rect>
            <text x={cx} y={166} textAnchor="middle" fill="#96a5b8" fontSize={9}>
              {d.label}
            </text>
          </g>
        );
      })}
    </svg>
  );
}

/** Agregă operațiunile pe ultimele `n` zile (create după `createdAt`, finalizate după `completedAt`). */
export function activityDays(
  ops: { createdAt: string; completedAt: string | null }[],
  n = 7,
  now = new Date(),
): ActivityDay[] {
  const days: ActivityDay[] = [];
  const start = new Date(now);
  start.setHours(0, 0, 0, 0);
  for (let i = n - 1; i >= 0; i--) {
    const d = new Date(start);
    d.setDate(start.getDate() - i);
    days.push({
      label: d.toLocaleDateString('ro-RO', { weekday: 'short' }).replace('.', ''),
      created: 0,
      done: 0,
    });
  }
  const index = (iso: string) => {
    const d = new Date(iso);
    d.setHours(0, 0, 0, 0);
    const diff = Math.round((d.getTime() - start.getTime()) / 86_400_000);
    const i = n - 1 + diff;
    return i >= 0 && i < n ? i : -1;
  };
  for (const o of ops) {
    const c = index(o.createdAt);
    if (c >= 0) days[c]!.created++;
    if (o.completedAt) {
      const f = index(o.completedAt);
      if (f >= 0) days[f]!.done++;
    }
  }
  return days;
}
